import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './routes';
import { applyTenantTheme } from './lib/tenant';
import { AuthProvider } from './lib/auth-context';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/globals.css';

applyTenantTheme();

/**
 * « La data doit être à jour, point » (Ben 30/07). Un écran laissé ouvert
 * affichait des chiffres de la veille sans le dire — la fenêtre 12 mois glisse
 * à minuit, et le CA d'un fournisseur avait changé de 1 380 € pendant la nuit.
 * Donc : on refetch au retour sur l'onglet et à la reconnexion réseau, plutôt
 * que de servir un cache muet. `staleTime` court = les données affichées ne
 * peuvent pas dater de plus de quelques secondes sans être revalidées.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Element #root introuvable dans index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
